(() => {
  const MAX_RETRIES = 20;
  const RETRY_DELAY_MS = 100;

  const initRoot = (root) => {
    if (!root || root.classList.contains('is-initialized')) return true;
    if (typeof Splide === 'undefined') return false;

    new Splide(root, {
      type: "loop",
      perPage: 1,
      padding: { left: "64px", right: "64px" },
      gap: 128,
      arrows: false,
      pagination: true,
      breakpoints: {
        1352: {
          padding: { left: "20px", right: "20px" },
          gap: 64,
        },
        767: {
          padding: { left: "16px", right: "16px" },
          gap: 32,
        },
      },
    }).mount();

    return true;
  };

  const initAll = () => {
    document.querySelectorAll('[data-c-new-slide]').forEach((root) => {
      initRoot(root);
    });
  };

  const waitForSplide = (retry = 0) => {
    if (typeof Splide !== 'undefined') {
      initAll();
      return;
    }

    if (retry < MAX_RETRIES) {
      setTimeout(() => waitForSplide(retry + 1), RETRY_DELAY_MS);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => waitForSplide());
  } else {
    waitForSplide();
  }

  document.addEventListener('shopify:section:load', () => waitForSplide());
})();
